import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

// Import all languages
const allModules = require.context("./", true, /\.(json)$/i);
var langs = {};

allModules.keys().forEach(function(mod) {
  if (mod != "./index.js") {
    // Language of the module
    const lang = mod.match(/\w+/)[0];
    const file = mod
      // Remove the path of the file
      .replace(/^.*[\\\/]/, "")
      // Remove the extension of the file
      .replace(/\.[^/.]+$/, "");
    // Put the result in the langs object
    if (typeof langs[lang] === "undefined") {
      langs[lang] = {};
    }
    langs[lang][file] = allModules(mod);
  }
});

export const i18n = new VueI18n({
  locale: "fr",
  fallbackLocale: "fr",
  messages: langs
});
